import { NgModule } from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SliderProductsComponent } from './slider-products/slider-products.component';
import { ProductPresentationComponent } from './product-presentation/product-presentation.component';
import { ProductMostrarioComponent } from './product-mostrario/product-mostrario.component';
import { ProductoBotonesTopComponent } from './producto-botones-top/producto-botones-top.component';
import { BannerPublicidadComponent } from './banner-publicidad/banner-publicidad.component';
import { GeneralesComponentsModule } from '../../../generales/components/components.module';
import { FilterComponent } from './filter/filter.component';
import { PasarelaPagoComponent } from './pasarela-pago/pasarela-pago.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DetailProductComponent } from './detail-product/detail-product.component';
import { ZoomImgComponent } from './zoom-img/zoom-img.component';
import { QrCodeStoreComponent } from './qr-code-store/qr-code-store.component';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { ComponentsAdminModule } from 'src/app/admin/components/components-admin.module';

const declarations = [
  SliderProductsComponent,
  ProductPresentationComponent,
  ProductMostrarioComponent,
  ProductoBotonesTopComponent,
  BannerPublicidadComponent,
  FilterComponent,
  PasarelaPagoComponent,
  DetailProductComponent,
  ZoomImgComponent,
  QrCodeStoreComponent
]

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    LayoutModule,
    ReactiveFormsModule,
    GeneralesComponentsModule,
    ComponentsAdminModule,
    FormsModule,
    TranslateModule,
    NgxQRCodeModule
  ],
  exports: declarations,
})
export class ComponentsModule {}
